/** Available versions of {@link RougeDataSet} */
var RgDataSetID;
(function (RgDataSetID) {
    RgDataSetID["uk_01"] = "uk_01";
    RgDataSetID["uk_02"] = "uk_02";
})(RgDataSetID || (RgDataSetID = {}));

export { RgDataSetID };
//# sourceMappingURL=rg-data-set-id.js.map
